import { render, staticRenderFns } from "./KeyUserOfUser.vue?vue&type=template&id=16bb7d84"
import script from "./KeyUserOfUser.vue?vue&type=script&lang=js"
export * from "./KeyUserOfUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports